<template>
    <div ref="editor" class="quill-editor"></div>
</template>
  
<script>
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
  
export default {
    name: 'QuillEditor',
    props: {
      modelValue: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: 'Escreva aqui...',
      },
    },
    emits: ['update:modelValue'],
    data() {
      return {
        quill: null,
      };
    },
    watch: {
      modelValue(newValue) {
        if (this.quill && this.quill.root.innerHTML !== newValue) {
          this.quill.root.innerHTML = newValue;
        }
      },
    },
    mounted() {
      this.quill = new Quill(this.$refs.editor, {
        theme: 'snow',
        placeholder: this.placeholder,
        modules: {
          toolbar: [
            [{ header: [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link', 'code-block'],
            ['clean'],
          ],
        },
      });
  
      // Define o valor inicial no editor
      if (this.modelValue) {
        this.quill.root.innerHTML = this.modelValue;
      }
  
      // Captura as mudanças no conteúdo do editor
      this.quill.on('text-change', () => {
        const content = this.quill.root.innerHTML;
        this.$emit('update:modelValue', content);
      });
    },
  };
</script>
  
<style>
.ql-toolbar.ql-snow {
    width: 100%;
}
.quill-editor {
    width: 100%;
    min-height: 150px;
    max-height: 400px;
    overflow-y: auto;
}
</style>
  